export default "__VITE_ASSET__CBxirxbt__"